<template>
  <b-table :data="productos" class="is-size-7">
    <b-table-column field="id" label="id" v-slot="props">
      {{ props.row.id }}
    </b-table-column>

    <b-table-column field="nombre" label="Nombre" v-slot="props">
      <span
        v-if="props.row.cantidad == 0"
        style="text-decoration: line-through"
        >{{ props.row.nombre }}</span
      >
      <span v-else>{{ props.row.nombre }}</span>
    </b-table-column>

    <b-table-column field="precio" label="Precio" v-slot="props">
      <span v-if="props.row.cantidad == 0" style="text-decoration: line-through"
        >${{ parseInt(props.row.precio).toLocaleString("es-CO") }}</span
      >
      <span v-else>{{
        parseInt(props.row.precio).toLocaleString("es-CO")
      }}</span>
    </b-table-column>

    <b-table-column field="cantidad" label="Cantidad" v-slot="props">
      {{ props.row.cantidad }}
    </b-table-column>

    <b-table-column field="subtotal" label="Subtotal" v-slot="props">
      <b
        >${{
          parseInt(props.row.precio * props.row.cantidad).toLocaleString(
            "es-CO"
          )
        }}</b
      >
    </b-table-column>

    <b-table-column field="fechaVenta" label="Fecha" v-slot="props">
      <span
        >{{ props.row.fechaVenta }}</span
      >
    </b-table-column>

    <b-table-column label="Acciones" v-slot="props">
      <b-button
        variant="danger"
        size="sm"
        @click="
          eliminarProducto(
            props.row.id,
            props.row.nombre,
            props.row.cantidad,
            props.row.id_vendidos,
            props.row.precio,
            props.row.idReferencia
          )
        "
      >
        <i class="material-icons">arrow_back</i>
      </b-button>
    </b-table-column>
  </b-table>
</template>
<script>
 import Swal from "sweetalert2";
import HttpService from "../../Servicios/HttpService";
export default {
  name: "TablaProductosVendidos",
  props: ["productos", "idTablaPadre","viene"],

  methods: {
  
    eliminarProducto(id, nombre, cantidadExistente, id_vendidos, precio, idReferencia) {
      const idUsuario = localStorage.getItem('id');
      console.log(this.viene)
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro que desea devolver el producto ${id} -- ${nombre}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, devolver',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Ingrese la cantidad a devolver:',
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Devolver',
            cancelButtonText: 'Cancelar',
            preConfirm: (cantidad) => {
              const regex = /^[0-9]*$/;
              if (!regex.test(cantidad)) {
                Swal.showValidationMessage('Ingrese una cantidad válida.');
                return false;
              }
              if (parseInt(cantidad) > cantidadExistente) {
                Swal.showValidationMessage('La cantidad ingresada es mayor a la cantidad vendida.');
                return false;
              }
              return cantidad;
            }
          }).then((cantidadResult) => {
            if (cantidadResult.isConfirmed) {
              const cantidad = cantidadResult.value;
              this.devolverInventario(id, cantidad);
              this.insertarValorDevolucion(cantidad, precio, idUsuario, idReferencia);
              this.descontarDineroDevolucion(cantidad, precio, this.viene, idReferencia);

              HttpService.eliminar("devolverarticulo.php", {
                id_vendidos: id_vendidos,
                cantidad: cantidad,
                id_producto: id,
                precio: precio,
                idReferencia: idReferencia,
              }).then((response) => {
                const eliminado = response === true;
                Swal.fire({
                  title: eliminado ? 'Producto Devuelto' : 'No se pudo eliminar la materia',
                  icon: eliminado ? 'success' : 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
              });
              console.log("Cantidad a devolver:", cantidad);
            }
          });
        }
      });
    },
    devolverInventario(id, cantidad){
      let payload = {
        accion: "devolverProducto",
        id:id,
        cantidad:cantidad,
      };
      HttpService.obtenerConConsultas("productos.php", payload).then(
        (clientes) => {
          this.registros = clientes;
          console.log(this.registros);
        }
      );
    },
    insertarValorDevolucion(cantidad,precio,idUsuario){
      let payload = {
        accion: "insertarValorDevolucion",
        cantidad,
        precio,
        idUsuario
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (clientes) => {
          this.registros = clientes;
          console.log(this.registros);
        }
      );
    },
    descontarDineroDevolucion(cantidad,precio,viene,idReferencia){
      console.log(cantidad, precio,viene +"idreferenia="+idReferencia)
      let payload = {
        accion: "descontarDineroDevolucion",
        cantidad,
        precio,
        viene,
        idReferencia,
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (clientes) => {
          this.registros = clientes;
          console.log(this.registros);
        }
      );
    },
  },
};
</script>
